import styled, { keyframes } from 'styled-components';

import { brand } from 'utils/environment';

import { IVisible } from './types';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const Screen = styled.div<IVisible>`
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  flex-direction: column;
  overflow: scroll;
  height: 100vh;
  background-color: ${Styles.color.background};
`;

export const Container = styled.main<IVisible>`
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  margin: auto;
  animation: ${fadeIn} 0.3s;

  // overwrites Pypestream styles to preserve our top navbar in mobile
  & #pypestream-wrapper {
    position: static !important;
  }
  & #pypestream-wrapper.showing {
    position: static !important;
  }

  // overwrites Pypestream styles to display a custom loading gif that resembles a live chat
  & .ps-loader-wrapper {
    background-image: url(/assets/${brand()}/pypestream-loader.gif);
    background-repeat: no-repeat;
    background-size: 100%;
    max-width: 100%;
    max-height: 100%;
    background-color: transparent;
    border-radius: 0;
    ${Styles.desktop`border-radius: 4px;`}
  }
  & .ps-loader {
    display: none;
  }
`;
